module.exports = __webpack_public_path__ + "static/media/healthcare_doc_slider_phone1.2b4d3ae7.png";